import React from "react";
import { Link } from "react-router-dom";
import { DashboardLayout } from "../../Components/Layout/DashboardLayout";

// Step-by-step guide for an admin to add the shared landmark pins that every
// resident sees on the rangefinder map. Instructions only — the actual tool is
// the Landmark Manager tile.
const STEPS = [
  "From the Rangefinder menu, open Landmark Manager.",
  'Click the "Add New Landmark" button.',
  "On the map, click the exact spot where the landmark is (clubhouse, pool, gate, gym, and so on). A pin drops where you click.",
  'Give the landmark a clear name (for example, "Marshwood Clubhouse") and pick a category.',
  "Add a short description if you want one. This step is optional.",
  'Click "Save". You will see a confirmation that the landmark was created.',
  "The pin appears right away on every resident's rangefinder map. A resident can tap it to get walking, cart, or driving directions to it.",
  "To change or remove a landmark later, open Landmark Manager, find it in the list, and use Edit or Delete. Residents see the change on their next visit.",
];

const wrap = { maxWidth: 760, margin: "0 auto", padding: "8px 4px" };
const card = { background: "#fff", border: "1px solid #e5e7eb", borderRadius: 12, padding: "10px 26px 22px" };
const stepRow = { display: "flex", gap: 14, padding: "14px 0", borderTop: "1px solid #f0f0f0", alignItems: "flex-start" };
const stepRowFirst = { ...stepRow, borderTop: "none" };
const num = {
  flex: "0 0 28px", width: 28, height: 28, borderRadius: 14, background: "#2196F3",
  color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700, fontSize: 14,
};
const stepText = { fontSize: 15, lineHeight: 1.55, color: "#1a1a1a", paddingTop: 3 };

const LandmarkGuide = () => {
  return (
    <DashboardLayout>
      <div style={wrap}>
        <div style={{ marginBottom: 16 }}>
          <Link to="/rangefinder" style={{ color: "#2196F3", textDecoration: "none", fontSize: 14 }}>
            &larr; Back to Rangefinder
          </Link>
          <h2 style={{ margin: "10px 0 4px", color: "#1A3C34" }}>How to Add Shared Landmarks</h2>
          <p style={{ color: "#6b7280", fontSize: 15, margin: 0 }}>
            Follow these steps to add a map pin that every resident sees on the rangefinder map.
          </p>
        </div>
        <div style={card}>
          {STEPS.map((step, i) => (
            <div key={i} style={i === 0 ? stepRowFirst : stepRow}>
              <div style={num}>{i + 1}</div>
              <div style={stepText}>{step}</div>
            </div>
          ))}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default LandmarkGuide;
